import { Component, OnInit, Inject } from "@angular/core";
import { UsersService } from "@service/users.service";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Profile } from "@model/Profile";

@Component({
  selector: "app-modal-attending",
  templateUrl: "./modal-attending.component.html",
  styleUrls: ["./modal-attending.component.scss"],
})
export class ModalAttendingComponent implements OnInit {
  attendingOptions = [
    { value: "graduation", viewText: "Graduação" },
    { value: "master", viewText: "Mestrado" },
    { value: "doctorate", viewText: "Doutorado" },
    { value: "post_doctorate", viewText: "Pós-Doutorado" },
    { value: "specialization", viewText: "Especialização" },
  ];

  selectedValue: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { userId: number },
    public dialogRef: MatDialogRef<ModalAttendingComponent>,
    private usersService: UsersService
  ) {}

  ngOnInit() {
    console.log(this.data.userId);
  }

  save() {
    this.usersService
      .updateAttending(this.data.userId, this.selectedValue)
      .subscribe(() => {
        const user: Profile = JSON.parse(localStorage.getItem("currentUser"));
        user.attending = this.selectedValue;
        localStorage.setItem("currentUser", JSON.stringify(user));
      });
  }

  changeSelected(value: string) {
    this.selectedValue = value;
  }
}
